import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './StartNavigationMain.html?raw';

import NavigationArea from '../../moreCore/UI/Navigation/NavigationArea';
import "../../moreCore/UI/Navigation/NavigationArea";
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import RequestManager from 'more/RequestManager';

class StartNavigationMain extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private navigationArea: MdsLax<InstanceType<typeof NavigationArea>>;
    private loadingBar: HTMLDivElement;
    private iconTiles: HTMLElement;
    private iconCompact: HTMLElement;
    private iconRows: HTMLElement;

    //sectionThemeToggle:HTMLDivElement;

    RequestManager;

    //#region postCreate
    postCreate() {
        super.postCreate.apply(this, arguments as any);

        let startLayout = localStorage.getItem("ego_StartNavigationLayout");
        if (startLayout) {
            this._currentLayout = startLayout as any;
            this.navigationArea.setLayout(this._currentLayout);
        }

        this.addSubscription("/Global/VisibilityChange", lang.hitch(this, this._onVisibilityChanged));
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.getTiles();

        this.hasUserRole(["_DEV", "admin", "evisSettings"], lang.hitch(this, this._onSettingsPrivilege));

        this.setLayout(this._currentLayout);
        this._handleLayoutIcon();

    }

    private _onVisibilityChanged() {
        try {
            if (this.navigationArea.getTiles().length) {
                this.StandbyStop();
            }
        } catch (ex) {

        }
    }

    private _onSettingsPrivilege(hasPriv: any) {
        if (hasPriv === true) {

            let settingsContainer = document.getElementById("settingsContainer");
            if (settingsContainer) this.hideNode(settingsContainer, false);
        }
    }

    getTiles() {
        this.StandbyStart();
        var url = window.appRoot + "Navigation/GetNavigationTiles";

        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, "drawTiles"),
            lang.hitch(this, "_getTilesError"),
            false // sync
        );
    }

    drawTiles(data: any) {
        this.StandbyStop();
        this.navigationArea.drawTiles(data.tiles);
    }

    private _getTilesError(error: any) {
        this.StandbyStop();
        alert(error.Message);
    }

    private _currentLayout: Navigation.TilesLayout = "tiles";
    private _onClick_LayoutTiles(evt: MouseEvent) {
        this.setLayout("tiles");
        evt.stopPropagation();
    } private _onClick_LayoutCompact(evt: MouseEvent) {
      
        this.setLayout("compact");
        evt.stopPropagation();
    }
    private _onClick_LayoutRows(evt: MouseEvent) {
        this.setLayout("rows");
        evt.stopPropagation();
    }
    private _onClick_LayoutToggle(evt: MouseEvent) {
        let nextLayout: Navigation.TilesLayout = "tiles";

        switch (this._currentLayout) {
            case "tiles":
                nextLayout = "compact";
                break;

            case "compact":
                nextLayout = "rows";
                break;

            case "rows":
                nextLayout = "tiles";
                break;
        }

        this.setLayout(nextLayout);
    }

    setLayout(layout: Navigation.TilesLayout) {
        if (layout == this._currentLayout) return;

        switch (layout) {
            case "tiles":
            case "compact":
            case "rows":
                this.navigationArea.setLayout(layout);
                this._currentLayout = layout;
                break;
        }

        localStorage.setItem("ego_StartNavigationLayout", this._currentLayout);

        this._handleLayoutIcon();
    }

    private _handleLayoutIcon() {
        this.UiModder.domClass.toggle(this.iconCompact, "primaryBG primaryOutline", this._currentLayout == "compact");
        this.UiModder.domClass.toggle(this.iconRows, "primaryBG primaryOutline", this._currentLayout == "rows");
        this.UiModder.domClass.toggle(this.iconTiles, "primaryBG primaryOutline", this._currentLayout == "tiles");
    }
    private _showloadingBarTimeout;

    StandbyStart(): dijit._WidgetBase {
        this.UiModder.domClass.replace(this.loadingBar, "ego_animated_progressBar", "hide");
        this._showloadingBarTimeout = setTimeout(lang.hitch(this, function (node) { this.UiModder.domClass.remove(node, "hide"); }, this.loadingBar), 100);
        return null;
    }

    StandbyStop() {
        if (this._showloadingBarTimeout) {
            clearTimeout(this._showloadingBarTimeout);
        }

        this.UiModder.domClass.add(this.loadingBar, "hide");

        setTimeout(lang.hitch(this, function (node) {
            this.UiModder.domClass.remove(this.loadingBar, "ego_animated_progressBar");
        }, this.loadingBar), 2000);
    }
}

mdsLazyProto(StartNavigationMain.prototype, {
  RequestManager: () => (new RequestManager()),
});
export default mdsWidget(StartNavigationMain);
